import { LicenseType } from './input-license.model';

export interface ITaskParallelizationSettings {
  enabled?: boolean;
  totalTaskLimit?: number;
  audioTaskLimit?: number;
  instantMessagingTaskLimit?: number;
  externalTaskLimit?: number;
  emailTaskLimit?: number;
  allowTaskActivationWhileInActiveTask?: boolean;
}

export const TASK_LIMIT_MIN = 1;
export const TASK_LIMIT_MAX = 20;

export const MODALITY_TASK_LIMIT_CONTROLS: ReadonlyArray<{ controlName: string; licenseType: LicenseType }> = [
  { controlName: 'audioTaskLimit', licenseType: LicenseType.AudioVideo },
  { controlName: 'instantMessagingTaskLimit', licenseType: LicenseType.InstantMessaging },
  { controlName: 'externalTaskLimit', licenseType: LicenseType.ExternalTask },
  { controlName: 'emailTaskLimit', licenseType: LicenseType.Email },
];

export function buildTaskParallelizationSettings(
  isEnabled: boolean,
  totalTaskLimit: number,
  licenses: LicenseType[],
  limits: Partial<ITaskParallelizationSettings>,
  isAllowTaskActivationWhileInActiveTask?: boolean,
): ITaskParallelizationSettings {
  if (!isEnabled) {
    return { enabled: false };
  }
  return {
    enabled: true,
    totalTaskLimit,
    ...(isAllowTaskActivationWhileInActiveTask !== undefined && {
      allowTaskActivationWhileInActiveTask: isAllowTaskActivationWhileInActiveTask,
    }),
    ...MODALITY_TASK_LIMIT_CONTROLS.reduce(
      (acc, { controlName, licenseType }) =>
        licenses.includes(licenseType) ? { ...acc, [controlName]: limits[controlName as keyof ITaskParallelizationSettings] } : acc,
      {},
    ),
  };
}
